const toNumber = (value) => Number(value) || 0

const normalizeSprawozdaniaList = (input) => {
    if (Array.isArray(input)) {
        return input
    }

    if (Array.isArray(input?.list)) {
        return input.list
    }

    return []
}

export const groupSprawozdaniaByQuarter = (input) => {
    const source = normalizeSprawozdaniaList(input)
    if (!source.length) {
        return []
    }

    const grouped = source.reduce((acc, item) => {
        const key = `${item?.rok}-${item?.kwartal}`
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(item)
        return acc
    }, {})

    return Object.values(grouped)
        .map((items) => {
            const sorted = [...items].sort((a, b) => {
                const wersjaDiff = toNumber(b?.wersja) - toNumber(a?.wersja)
                if (wersjaDiff !== 0) {
                    return wersjaDiff
                }
                return toNumber(b?.id) - toNumber(a?.id)
            })

            const latest = sorted[0]
            return {
                ...latest,
                sprawozdanieIds: sorted.map((entry) => entry.id),
                historiaLabel: latest?.numer,
            }
        })
        .sort((a, b) => {
            if (toNumber(b?.rok) !== toNumber(a?.rok)) {
                return toNumber(b?.rok) - toNumber(a?.rok)
            }
            return toNumber(b?.kwartal) - toNumber(a?.kwartal)
        })
}
